import React from 'react';

// Building blocks shared by the statistics pages (Laporan dan Data Statistik, Statistik i-WARAN).
export const BarList = ({ rows, valueKey = 'total', labelKey = 'label', emptyText }) => {
    const max = Math.max(1, ...rows.map((row) => Number(row[valueKey] || 0)));
    if (!rows.length) {
        return <div className="app-empty">{emptyText}</div>;
    }
    return (
        <div className="app-report-bars">
            {rows.map((row) => (
                <div key={row[labelKey]} className="app-report-bar-row">
                    <div className="app-report-bar-label" title={row[labelKey]}>{row[labelKey]}</div>
                    <div className="app-report-bar-track">
                        <div className="app-report-bar-fill" style={{ width: `${(Number(row[valueKey] || 0) / max) * 100}%` }}></div>
                    </div>
                    <div className="app-report-bar-value">{row[valueKey] || 0}</div>
                </div>
            ))}
        </div>
    );
};

export const Table = ({ columns, rows, rowKey, footer }) => {
    const template = columns.map((column) => column.width || '0.4fr').join(' ');
    return (
        <div className="app-inline-table app-inline-clean">
            <div className="app-inline-table-header" style={{ gridTemplateColumns: template }}>
                {columns.map((column) => <span key={column.key}>{column.label}</span>)}
            </div>
            {rows.map((row, index) => (
                <div key={rowKey(row, index)} className="app-inline-table-row" style={{ gridTemplateColumns: template }}>
                    {columns.map((column) => <span key={column.key}>{column.render ? column.render(row) : (row[column.key] ?? 0)}</span>)}
                </div>
            ))}
            {footer && (
                <div className="app-inline-table-row" style={{ gridTemplateColumns: template, fontWeight: 700 }}>
                    {columns.map((column) => <span key={`footer-${column.key}`}>{footer[column.key] ?? ''}</span>)}
                </div>
            )}
        </div>
    );
};
